import { render, staticRenderFns } from "./DataToCollect.vue?vue&type=template&id=56d81d3d&scoped=true&"
import script from "./DataToCollect.vue?vue&type=script&lang=js&"
export * from "./DataToCollect.vue?vue&type=script&lang=js&"
import style0 from "./DataToCollect.vue?vue&type=style&index=0&id=56d81d3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d81d3d",
  null
  
)

export default component.exports